import * as React from 'react';
import {MetaMenu} from "../Components/MetaMenu/MetaMenu";
import styled from "styled-components";
import {Tile} from "../Components/Tile";
import {Colors, MediaBreakpoints} from "../Styles";
import {ArrowRightIcon} from "../Components/Icons";
import {Pill} from "../Components/Pill";
import {GTMDataLayerPush} from "../Util/GoogleTagManager";

interface StyleProps {
    hasHeight?: boolean;
}

const StyledExtensionsListView = styled.div<StyleProps>`
    padding: 10px 20px;
    overflow: auto;
    
    @media ${MediaBreakpoints.medium} {
        padding: 90px 100px;
    }
`;

interface Browser {
    id: "edge" | "chrome" | "firefox" | "word";
    iconPath: string;
    alt: string;
    name: string;
    text: string;
    storeUrl: string;
}

const StyledExtensionsList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
`;

const StyledExtensionListItem = styled.li`
  margin: 0 40px 25px 0;
`;

const browsers: Browser[] = [
    {
        id: "edge",
        iconPath: "/assets/icons/logo-edge.svg",
        alt: "Edge Logo",
        name: "Microsoft Edge",
        text: "Mit unserer Browser-Erweiterung prüft der Mentor Ihre Texteingaben auf zahlreichen Internetseiten.",
        storeUrl: "https://microsoftedge.microsoft.com/addons/detail/dudenmentortextpr%C3%BCfung/bmggehagjjhlpcmpllhldmcopgiabnpe"
    },
    {
        id: "firefox",
        iconPath: "/assets/icons/logo-firefox.svg",
        alt: "Firefox Logo",
        name: "Mozilla Firefox",
        text: "Gewinnen Sie Sicherheit und korrigieren Sie Ihre Texte an Ort und Stelle im Browser von Mozilla.",
        storeUrl: "https://addons.mozilla.org/de/firefox/addon/duden-mentor-textpr%C3%BCfung/"
    },
    {
        id: "chrome",
        iconPath: "/assets/icons/logo-chrome.svg",
        alt: "Chrome Logo",
        name: "Google Chrome",
        text: "Auch in Chrome steht Ihnen der Duden-Mentor als Erweiterung stets zur Seite.",
        storeUrl: "https://chrome.google.com/webstore/detail/duden-mentor-textpr%C3%BCfung/jkennnbhkennnbeebfonckakbodfaldk?hl=de"
    }
];
const word: Browser = {
            id: "word",
            iconPath: "/assets/icons/logo-word.svg",
            alt: "Word Logo",
            name: "Microsoft Word",
            text: "Korrekturen und Stiltipps von Duden direkt in Word - das Mentor-Add-in macht es möglich.",
            storeUrl: "https://appsource.microsoft.com/de-de/product/office/WA200002017"
        };

export const Extensions = (props: Props) => {
    function isCurrentBrowser(browserId: string): boolean {
        return browserId === getCurrentBrowserId();
    }

    function getCurrentBrowserId() : string {
        let sUsrAg = navigator.userAgent;

        if (/Firefox\/[0-9]*.[0-9]/g.test(sUsrAg) && !(/Seamonkey\/[0-9]*.[0-9]/g.test(sUsrAg))) {
            return "firefox";
        } else if (sUsrAg.toLowerCase().indexOf("edg") > -1) {
            return "edge";
        } else if (/Chrome\/[0-9]*.[0-9]*/g.test(sUsrAg) && !(/OPR\/[0-9]*.[0-9]*/g.test(sUsrAg))) {
            return "chrome";
        }
        return "";
    }

    function getSortedBrowser(): Browser[]  {
        const currentBrowserId = getCurrentBrowserId()
        const currentBrowserPosition = browsers.findIndex(b => b.id === currentBrowserId);
        const sortedBrowsers = [...browsers.slice(currentBrowserPosition), ...browsers.slice(0, currentBrowserPosition)];
        sortedBrowsers.push(word);

        return sortedBrowsers;
    }

    return (
        <React.Fragment>
            <StyledExtensionsListView hasHeight={props.hasHeight}>
                <h1>Erweiterungen</h1>
                <StyledExtensionsList>
                    {getSortedBrowser().map(browser => (
                        <StyledExtensionListItem key={browser.id}>
                            <Tile
                                heading={
                                    <React.Fragment>
                                        <img width="62" height="62" src={browser.iconPath} alt={browser.alt} />
                                        <h2>
                                            {`Duden-Mentor für ${browser.name}`}
                                            {isCurrentBrowser(browser.id) && <Pill color={Colors.grannySmithApple} fontSize={13}>Ihr aktueller Browser</Pill>}
                                        </h2>
                                    </React.Fragment>
                                }
                                backgroundColor={isCurrentBrowser(browser.id) ? `${Colors.mystic}` : `${Colors.bajaWhite}`}
                                button={<a className="dark" target='_blank' onClick={() => GTMDataLayerPush({event: "select-extension-store", option: browser.id})} href={browser.storeUrl}>Installieren<ArrowRightIcon /></a>}
                            >
                                <p>{browser.text}</p>
                            </Tile>
                        </StyledExtensionListItem>
                    ))}
                </StyledExtensionsList>
            </StyledExtensionsListView>
            <MetaMenu />
        </React.Fragment>
    );
}